// @generated by protoc-gen-es v2.12.0 with parameter "target=ts,import_extension=js"
// @generated from file morfi/v1/markets/boosting.proto (package morfi.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { EventMetadata } from "../common_pb.js";
import { file_morfi_v1_common } from "../common_pb.js";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file morfi/v1/markets/boosting.proto.
 */
export const file_morfi_v1_markets_boosting: GenFile = /*@__PURE__*/
  fileDesc("Ch9tb3JmaS92MS9tYXJrZXRzL2Jvb3N0aW5nLnByb3RvEghtb3JmaS52MSKaAQoSTWFya2V0Qm9vc3RlZEV2ZW50EiUKBG1ldGEYASABKAsyFy5tb3JmaS52MS5FdmVudE1ldGFkYXRhEg4KBm1hcmtldBgCIAEoDBIPCgdib29zdGVyGAMgASgMEgoKAnRzGAQgASgDEhoKEnByaXplX3Bvb2xfYWRkcmVzcxgFIAEoDBIUCgxhbW91bnRfcXVvdGUYBiABKAQiYAoLTWFya2V0Qm9vc3QSEwoLc2VxdWVuY2VfaWQYASABKAwSCgoCdHMYAiABKAQSDgoGbWFya2V0GAMgASgJEg0KBWFjdG9yGAQgASgJEhEKCWFtb3VudF9kNhgFIAEoBGIGcHJvdG8z", [file_morfi_v1_common]);

/**
 * @generated from message morfi.v1.MarketBoostedEvent
 */
export type MarketBoostedEvent = Message<"morfi.v1.MarketBoostedEvent"> & {
  /**
   * @generated from field: morfi.v1.EventMetadata meta = 1;
   */
  meta?: EventMetadata | undefined;

  /**
   * @generated from field: bytes market = 2;
   */
  market: Uint8Array;

  /**
   * @generated from field: bytes booster = 3;
   */
  booster: Uint8Array;

  /**
   * @generated from field: int64 ts = 4;
   */
  ts: bigint;

  /**
   * @generated from field: bytes prize_pool_address = 5;
   */
  prizePoolAddress: Uint8Array;

  /**
   * @generated from field: uint64 amount_quote = 6;
   */
  amountQuote: bigint;
};

/**
 * Describes the message morfi.v1.MarketBoostedEvent.
 * Use `create(MarketBoostedEventSchema)` to create a new message.
 */
export const MarketBoostedEventSchema: GenMessage<MarketBoostedEvent> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_boosting, 0);

/**
 * Typed realtime payload for both market- and user-scoped boost subjects.
 * User-scoped subjects need the market in-band for activity-feed routing.
 *
 * @generated from message morfi.v1.MarketBoost
 */
export type MarketBoost = Message<"morfi.v1.MarketBoost"> & {
  /**
   * @generated from field: bytes sequence_id = 1;
   */
  sequenceId: Uint8Array;

  /**
   * @generated from field: uint64 ts = 2;
   */
  ts: bigint;

  /**
   * @generated from field: string market = 3;
   */
  market: string;

  /**
   * @generated from field: string actor = 4;
   */
  actor: string;

  /**
   * @generated from field: uint64 amount_d6 = 5;
   */
  amountD6: bigint;
};

/**
 * Describes the message morfi.v1.MarketBoost.
 * Use `create(MarketBoostSchema)` to create a new message.
 */
export const MarketBoostSchema: GenMessage<MarketBoost> = /*@__PURE__*/
  messageDesc(file_morfi_v1_markets_boosting, 1);

